<template>
  <div class="FormArticle">
    <FormSect>
      <Row>
        <Column :md="4">
          <FormArticleImage
            :article="article"
            :fileId.sync="article.imageFileId"
            imageDropId="coverImage"
            type="ARTICLE_HERO_IMAGE" />
        </Column>
        <Column :md="6">
          <Field
            :label=" $t('site')"
            :options="siteOptions"
            required
            type="select"
            :value.sync="article.siteId" />
          <Field
            :label="$t('topic')"
            :maxlength="100"
            :minlength="1"
            required
            :value.sync="article.topic" />
        </Column>
        <Column :md="2">
          <Field
            :label="$t('category')"
            :options="categories"
            required
            type="select"
            :value.sync="article.category" />
          <Field
            :label="$t('modifier')"
            :options="articleModifiersOptions"
            required
            type="select"
            :value.sync="article.modifier" />
        </Column>
      </Row>
    </FormSect>

    <FormSect :title="$t('sections')">
      <FormSections
        :article="article"
        :sections="article.sections"
        @update:article="$up('article', $event)"
        @update:sections="$up('article.sections', $event)" />
    </FormSect>

    <FormArticleLaptops
      v-if="canHaveProducts"
      :article="article"
      :articleLaptops="article.laptops"
      :criteria="article.criteria"
      @update:article="$up('article', $event)"
      @update:articleLaptops="$up('article.laptops', $event)"
      @update:criteria="$up('article.criteria', $event)" />
  </div>
</template>

<script>
import { actions, getters } from '@utils'
import { ARTICLE_TYPES } from '@store/modules/article'
import FormArticleImage from '@forms/FormArticleImage'
import FormArticleLaptops from './../FormArticleLaptops'
import FormSections from './FormSections'
import Message from '@mixins/Message'
import createSpreadsheetParagraph from './createSpreadsheetParagraph'

export default {
  mixins: [Message],
  components: {
    FormArticleImage,
    FormArticleLaptops,
    FormSections,
  },
  props: {
    article: Object,
  },
  data() {
    return {
      isCreatingSpreadsheetParagraph: false,
    }
  },
  computed: {
    articleVariantFocused() {
      const { introVariants, introVariantIndex } = this.article
      return introVariants[introVariantIndex]
    },
    canHaveProducts() {
      return this.article.type === ARTICLE_TYPES.BUYING_GUIDE
    },
    ...getters(
      'articleModifiersOptions',
      'categories',
      'siteOptions',
      'specTypes',
    ),
  },
  methods: {
    createSpreadsheetParagraph,
    async generateSpreadsheetParagraphVariant() {
      const { variants } = await this.$wrap(
        this.CREATE_COMPLETION({
          type: 'GENERATE',
          promptTemplateName: 'SPREADSHEET_PARAGRAPH',
          category: this.article.category,
          fields: {
            category: this.article.category,
            topic: this.article.topic,
          },
        }),
        'isCreatingSpreadsheetParagraph',
        this.$t('spreadsheetParagraphCreated'),
      )

      return variants[0].text
    },
    updateVariantFocused(text) {
      const { introVariants, introVariantIndex } = this.article
      introVariants[introVariantIndex] = text
      this.article.introVariants = [...introVariants]
    },
    fillPromptIntro() {
      return (text) =>
        this.CREATE_INTRO_COMPLETION({ article: this.article, text })
    },
    ...actions(
      'CREATE_COMPLETION',
      'CREATE_INTRO_COMPLETION',
      'PREFILL_BATCH',
    ),
  },
}
</script>

<style lang="scss">
.FormArticle {
  margin-bottom: $grid-unit;
}
</style>

<i18n>
{
  "en": {
    "category": "Category",
    "createSpreadsheetParagraph": "Create spreadsheet paragraph",
    "intro": "Intro",
    "keyFacts": "Key facts",
    "laptops": "Laptops",
    "modifier": "Modifier",
    "outro": "Outro",
    "sections": "Sections",
    "site": "Site",
    "spreadsheetParagraphCreated": "Sreadsheet paragraph created",
    "text": "Text",
    "topic": "Topic"
  }
}
</i18n>
